import { render, staticRenderFns } from "./DevBpbjStandardZyInfo.vue?vue&type=template&id=7140dd8b&scoped=true&"
import script from "./DevBpbjStandardZyInfo.vue?vue&type=script&lang=js&"
export * from "./DevBpbjStandardZyInfo.vue?vue&type=script&lang=js&"
import style0 from "./DevBpbjStandardZyInfo.vue?vue&type=style&index=0&id=7140dd8b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7140dd8b",
  null
  
)

export default component.exports